import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import { StyleSheet } from 'react-native';
import { Col, ListItem, Row, TextBody } from '../../atoms';
import { ApyLabel } from '../../organisms';
export const _MarketListItem = memo(({ addon, align = 'center', apy, coinIcon, displayCode, footer, id, onPress, subtitle, trending = false, style, }) => {
    let subtitleEl = null;
    if (typeof subtitle === 'string') {
        subtitleEl = _jsx(TextBody, { children: subtitle });
    }
    else if (subtitle) {
        subtitleEl = subtitle;
    }
    return (_jsxs(ListItem, { id: id, onPress: onPress, style: [$.container, align === 'top' && $.alignTop, style], children: [coinIcon && (_jsx(Col, { mt: align === 'top' ? '2' : undefined, mr: "3", children: coinIcon })), _jsxs(Col, { style: $.content, children: [_jsxs(Row.LR, { children: [_jsxs(Col, { children: [_jsxs(Row.L, { children: [_jsx(TextBody, { xem: true, children: displayCode }), !!apy && apy.gt(0) && (_jsx(Col, { ml: "1", children: _jsx(ApyLabel, { value: apy }) })), !!trending && _jsx(TextBody, { ml: "1", children: "\uD83D\uDD25" })] }), !!subtitleEl && _jsx(Col, { style: $.subtitle, children: subtitleEl })] }), !!addon && addon] }), !!footer && footer] })] }));
});
const $ = StyleSheet.create({
    container: {
        minHeight: 60,
        paddingVertical: 0,
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    alignTop: {
        alignItems: 'flex-start',
    },
    content: {
        flex: 1,
    },
    subtitle: {
        marginTop: 2,
    },
});
